






















import { Component, Prop, Vue } from 'nuxt-property-decorator';
import { extractBlocks } from './helpers';
import { ICmsBlock } from './helpers/renderContent';

@Component({})
export default class LayoutPlaceholder extends Vue {
	@Prop({ type: String }) name!: string;
	@Prop({ type: Number, default: 0 }) level!: number;
	@Prop({
		type: Array,
		default() {
			return [];
		},
	})
	blocks!: ICmsBlock[];
	@Prop({
		type: Object,
		default() {
			return {};
		}
	})
	externalData?: any;

	currentLevel = 0;

	get renderBlocks (): ICmsBlock[] {
		let blocks: any = [];

		[...this.blocks]
			.map((block: any) => {
				if (block.extras?.placeholder && block.placeholders && block.placeholders?.[block.extras?.placeholder]) {
					const placeholder = block.placeholders?.[block?.extras?.placeholder]

					if (Array.isArray(placeholder)) {
						blocks.push(...placeholder)
						return
					}

					blocks.push(placeholder)
				}

				blocks.push(block)
			})

		return extractBlocks(blocks)
	}

	created(): void {
		this.currentLevel = this.level;
	}
}
